<template>
  <transition name="fade">
    <ProfileCropper v-if="pModal" @imageCropped="updateImage" @changeVisibility="pModal = false"/>
  </transition>
  <UserSkeleton v-if="loading"/>
  <section v-else class="w-screen h-full dark:bg-gray-900 flex pb-32 pt-8">
      <div class="w-3/5 h-auto mx-auto flex rounded-lg dark:bg-gray-900">
        <span class="mx-auto text-gray-300 w-3/4">
          <span class="">
            <div v-if="!edit" class="h-48 w-48 bg-indigo-800 rounded-full mx-auto">
              <img v-if="user.avatar" class="rounded-full " :src="user.avatar" alt="">
              <span v-else class="h-full w-full flex"><p class="m-auto text-gray-100 text-7xl">{{minify}}</p></span>
            </div>
            <div @click="pModal = true" v-else class="group h-48 w-48 bg-gray-700 rounded-full mx-auto flex items-center cursor-pointer">
              <span class="relative w-full h-full rounded-full">
                <span :class="!imageSrc ? 'opacity-100' : 'opacity-0'" class="z-10 material-icons-outlined absolute transform -translate-x-1/2 left-1/2 -translate-y-1/2 top-1/2 text-7xl transition-all group-hover:opacity-100 duration-300 ">
                  {{'add_a_photo'}}
                </span>
                <img class="rounded-full filter transition-all duration-700 group-hover:blur group-hover:opacity-0" :src="imageSrc"/>
              </span>
            </div>
            <p class=" rounded-full mt-4 text-2xl capitalize text-center text-indigo-500 dark:text-gray-100 mx-auto">{{userOriginal.nome}}</p>
            <p :class="userOriginal.role === 'administrador' ? 'bg-indigo-500' :'bg-pink-400'" class="w-40 rounded-full mt-1 text-lg capitalize text-center text-gray-100 mx-auto bg-opacity-80">{{userOriginal.role}}</p>
            <button v-if="!edit" @click="edit = !edit; password=''; confirm=''" class="w-full mt-4 text-center text-indigo-600 dark:text-indigo-100">Editar perfil</button>
            <button v-else @click="cancelChanges()" class="w-full mt-4 text-center text-indigo-600 dark:text-indigo-100">Cancelar edições</button>
            <span v-if="edit" class="flex w-full">
              <button @click="saveChanges()" class="btn w-32 mx-auto rounded-full mt-4 p-2 text-center bg-indigo-500 text-indigo-100" :disabled="v$.userV.$invalid ">Salvar</button>
            </span>
          </span>
          <div class="mt-8 flex flex-wrap gap-y-4 gap-x-2">
            <p class="text-lg w-full uppercase text-gray-500 dark:text-gray-200">Sobre</p>
            <p class="text-sm uppercase text-gray-500 dark:text-gray-200">Dados Pessoais</p>
            <span class="w-full">
              <Input label="Nome Completo" type="text" :disabled="!edit" v-model="user.nome" :validation="v$.userV.nome"/>
            </span>
            <span class="w-1/2">
              <Input label="Email" :disabled="true" v-model="user.email"/>
            </span>
            <span class="flex-1">
              <Input label="Telefone" :disabled="!edit" v-model="user.telefone" v-maska="['(##) # ####-####', '(##) ####-####']" :validation="v$.userV.telefone"/>
            </span>
            <span class="flex-1">
              <Input label="Ramal" :disabled="!edit" v-model="user.ramal" />
            </span>
            <p v-if="edit && viewerUserRole === 'administrador'" class="text-sm uppercase w-full  text-gray-500 dark:text-gray-200">Controle de acesso ao sistema</p>
            <span v-if="viewerUserRole === 'administrador'" class="w-full">
              <Select label="Cargo" v-model="user.role" placeholder="Selecionar cargo" :list="[{'id': 1, 'descricao': 'Administrador'}, {'id': 2, 'descricao': 'Pesquisador'}]" desc="descricao" :disabled="!edit" :validation="v$.userV.role"/>
            </span>
            <button class="btn uppercase text-red-500 text-xs" :class="user.ativo ? 'text-red-500' : 'text-green-500'" @click="user.ativo = !user.ativo"
             v-if="edit && viewerUserRole === 'administrador'">{{user.ativo ? 'Desativar' : 'Ativar'}} usuário</button>
          </div>
          <div class="mt-8 flex flex-wrap gap-y-4 gap-x-2">
          </div>
          <div v-if="viewerUserId === userOriginal.id" class="mt-8 flex flex-wrap gap-y-4 gap-x-2">
            <p class="text-lg w-full uppercase text-gray-500 dark:text-gray-200">Senha</p>
            <p class="text-sm uppercase text-gray-500 w-full dark:text-gray-200">Alterar senha</p>
            <span class="w-1/2">
              <Input type="password" v-model="atual" label="Senha atual" :disabled="false" :validation="v$.password.atual"/>
            </span>
            <span class="w-1/2">
              <Input type="password" v-model="password" label="Nova senha" :disabled="false" :validation="v$.password.password"/>
            </span>
            <span class="flex-1">
              <Input type="password" v-model="confirm" label="Nova senha (confirmação)" :disabled="false" :validation="v$.password.confirm" />
            </span>
            <span class="w-full">
              <button v-if="v$.password.$anyDirty" @click="cancelChangePass()" class="btn mt-2 text-sm w-1/2 mx-auto text-center uppercase text-gray-500 dark:text-gray-200 cursor-pointer block">Cancelar</button>
              <button @click="changePassword()" class="text-sm mt-3 w-1/2 mx-auto rounded-full text-center btn p-2 uppercase text-gray-500 dark:text-gray-200 cursor-pointer bg-indigo-500 block" :disabled="v$.password.$invalid">Alterar senha</button>
            </span>
          </div>
        </span>
      </div>
  </section>
</template>

<script>
import { ref } from '@vue/reactivity'
import { computed, onMounted } from '@vue/runtime-core'
import { CHANGE_PASSWORD, GET_USUARIO_BY_ID, POST_AVATAR, PUT_USUARIO } from '../mixins/api'
import { useRoute } from 'vue-router'
import { telephoneMask } from '../mixins/mask'
import Input from '../components/Design/Input.vue'
import Select from '../components/Design/Select.vue'
import ProfileCropper from '../components/Usuarios/ProfileCropper.vue'
import UserSkeleton from '../components/Usuarios/UserSkeleton.vue'
import { useStore } from 'vuex'
import { displayNotification } from '../mixins/notification'
import useVuelidate from '@vuelidate/core'
import { personName, phone, passwordRegistration } from '@/mixins/validators.js'
import { required, helpers } from '@vuelidate/validators'
export default {
    components: { Input, ProfileCropper, UserSkeleton, Select },
    name: 'Profile',
    setup () {
        const userOriginal = ref({})
        const user = ref({})
        const minify = ref('')

        const edit = ref(false)
        const route = useRoute()

        const store = useStore()
        const viewerUserRole = ref('')
        const viewerUserId = ref(0)
        viewerUserId.value = store.getters['auth/user'].id
        viewerUserRole.value = store.getters['auth/user'].role

        const ativo = ref(0)

        const atual = ref('')
        const password = ref('')
        const confirm = ref('')

        const phoneMask = telephoneMask
        const pModal = ref(false)

        const imageSrc = ref(null)
        const formFile = ref(null)
        formFile.value = new FormData()

        const loading = ref(false)
        const getUser = async () => {
            await GET_USUARIO_BY_ID(route.params.id).then(r => {
                userOriginal.value = r.data.data
                if (parseInt(userOriginal.value.id) === parseInt(viewerUserId.value)) {
                    store.dispatch('auth/updateUser', userOriginal.value)
                }
                user.value = { ...userOriginal.value }
                user.value.telefone = user.value.telefone.toString()
                if (user.value.telefone.length > 10) {
                    user.value.telefone = '(' + user.value.telefone.slice(0, 2) + ') ' + user.value.telefone[2] + ' ' + user.value.telefone.slice(3, 7) + '-' + user.value.telefone.slice(7, 11)
                } else {
                    user.value.telefone = '(' + user.value.telefone.slice(0, 2) + ') ' + user.value.telefone.slice(2, 6) + '-' + user.value.telefone.slice(6, 10)
                }
                minify.value = userOriginal.value.nome[0] + '' + userOriginal.value.nome.split(' ')[1][0]
            })
        }
        onMounted(async () => {
            loading.value = true
            await getUser()
            loading.value = false
        })

        const cancelChanges = () => {
            user.value = { ...userOriginal.value }
            edit.value = false
            imageSrc.value = null
            v$.value.userV.$reset()
        }

        const cancelChangePass = () => {
            atual.value = ''
            password.value = ''
            confirm.value = ''
            v$.value.password.$reset()
        }
        const updateImage = (blob) => {
            const extension = '.' + blob.type.split('/')[1]
            const filename = 'avatar' + extension

            const fileReader = new FileReader()
            fileReader.readAsDataURL(blob)
            fileReader.onload = (e) => {
                imageSrc.value = e.target.result
            }

            formFile.value.append('avatar', blob, filename)
            formFile.value.append('id', userOriginal.value.id)
            pModal.value = false
        }
        const saveChanges = async () => {
            const body = {
                ...user.value
            }
            delete body.email
            delete body.avatar
            body.telefone = body.telefone.toString().replace('(', '').replace(')', '').replace('-', '').replace(' ', '').replace(' ', '')
            body.role = body.role.toLowerCase()
            body.ativo = body.ativo ? 1 : 0
            const p1 = PUT_USUARIO(userOriginal.value.id, body)
            let p2 = null

            if (formFile.value.getAll('avatar').length !== 0) {
                p2 = POST_AVATAR(formFile.value)
            }

            Promise.all([p1, p2]).then(async (results) => {
                displayNotification(results[0])
                if (p2) {
                    displayNotification(results[1])
                }
                await getUser()
            }).catch(errors => {
                displayNotification(errors[0])
                displayNotification(errors[1])
            })

            edit.value = false
        }

        const changePassword = () => {
            const body = {
                password: atual.value,
                novaSenha: password.value,
                confirmarSenha: confirm.value
            }
            CHANGE_PASSWORD(body).then(r => {
                displayNotification(r)
                atual.value = ''
                password.value = ''
                confirm.value = ''
            }).catch(e => {
                displayNotification(e.response)
            })
        }

        const rules = computed(() => {
            return {
                userV: {
                    nome: personName(),
                    telefone: phone(),
                    role: { required: helpers.withMessage('Este campo é obrigatório', required) }
                },
                password: {
                    password: passwordRegistration(),
                    confirm: {
                        required:
                  helpers.withMessage('Este campo é obrigatório', required),
                        sameAs:
                  helpers.withMessage('As senhas devem ser iguais', (value) => value === password.value)
                    },
                    atual: { required: helpers.withMessage('Este campo é obrigatório', required) }
                }
            }
        })
        const v$ = useVuelidate(rules, { userV: user, password: { password, confirm, atual } })

        return {
            user,
            edit,
            viewerUserId,
            viewerUserRole,
            phoneMask,
            updateImage,
            ativo,
            atual,
            password,
            confirm,
            pModal,
            cancelChanges,
            saveChanges,
            loading,
            imageSrc,
            changePassword,
            userOriginal,
            minify,
            v$,
            cancelChangePass
        }
    }

}
</script>

<style>
</style>
